import React from 'react';
import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react';
import { IFiguresAndTablesFile } from '@publishing-engine/domain/models';
import FileViewerButtonText from '../../FileViewerButtonText';

interface TablesProps {
  tables?: IFiguresAndTablesFile;
}

const TablesDisplay: React.FC<TablesProps> = ({ tables }) => {
  const renderSection = (items: IFiguresAndTablesFile) => (
    <Box mb={6}>
      <Box borderRadius="md">
        <Table width="100%">
          <Thead>
            <Tr
              gap={4}
              sx={{
                '& th': {
                  textTransform: 'none',
                  color: 'black',
                  background: 'white'
                }
              }}
            >
              <Th>
                <Text textStyle="headingItem" whiteSpace="nowrap">
                  Table No.
                </Text>
              </Th>
              <Th whiteSpace="nowrap">
                <Text textStyle="headingItem" whiteSpace="nowrap">
                  Caption
                  <Box as="span" color="red.500">
                    *
                  </Box>
                </Text>
              </Th>
              <Th>
                <Text textStyle="headingItem">
                  File
                  <Box as="span" color="red.500">
                    *
                  </Box>
                </Text>
              </Th>
            </Tr>
          </Thead>

          <Tbody>
            {items.map((item, idx) => {
              const parentFile = item.file ?? null;

              return (
                <React.Fragment key={idx}>
                  {/* Parent row */}
                  <Tr background="white">
                    <Td>Table {idx + 1}</Td>

                    {/* Caption */}
                    <Td>
                      <Flex direction="column" gap={2}>
                        {item.caption ? (
                          <Text textStyle="textBody">{item.caption}</Text>
                        ) : (
                          <Text as="span" color="neutralSecondaryContent">
                            No caption provided
                          </Text>
                        )}
                      </Flex>
                    </Td>

                    {/* File */}
                    <Td>
                      {parentFile ? (
                        <Flex direction="column" gap={1}>
                          <Box
                            key={parentFile.url || parentFile.id}
                            cursor="pointer"
                          >
                            <FileViewerButtonText
                              textStyle="textBody"
                              color="actionPrimaryFill"
                              fontWeight="bold"
                              wordBreak="break-word"
                              textAlign="initial"
                              whiteSpace="normal"
                              file={parentFile}
                            >
                              {parentFile.name}
                            </FileViewerButtonText>
                          </Box>
                        </Flex>
                      ) : (
                        <Text as="span" color="gray.500">
                          Composite Figures Provided
                        </Text>
                      )}
                    </Td>
                  </Tr>
                </React.Fragment>
              );
            })}
          </Tbody>
        </Table>
      </Box>
    </Box>
  );

  return <>{tables && renderSection(tables)}</>;
};

export default TablesDisplay;
